import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { MobileBrowse } from 'module-tsl-ui-mobile-browse';
import WithDocgen from 'module-tsl-ui-mobile-browse/with-docs/MobileBrowse';
import pkg from 'module-tsl-ui-mobile-browse/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`<div style={{ backgroundColor: '#FAFAFA', padding: 10 }}>
  <MobileBrowse groups={[
  {
    label: 'First menu item',
    navItems: [
      { label: 'SubMenu item', url: '#', id: 1 },
      { ...{ label: 'SubMenu item secondary', url: '#', indented: true }, id: 2 },
      { ...{ label: 'SubMenu item secondary', url: '#', indented: true }, id: 3 },
      { ...{ label: 'SubMenu item secondary', url: '#', indented: true }, id: 4 },
      { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 5 },
      { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 6 },
      { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 7 },
      { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 8 },
      { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 9 },
      { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 10 },
    ],
  },
  {
    label: 'Second Menu item',
    navItems: [{ label: 'SubMenu item', url: '#', id: 1 }, { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 2, indented: true }, { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 3 }],
    secondaryNav: {
      label: 'this is a secondary menu',
      navItems: [{ label: 'SubMenu item', url: '#', id: 1 }, { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 2 }, { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 3 }],
    },
  },
  {
    label: 'Third menu item',
    navItems: [{ label: 'SubMenu item', url: '#', id: 1 }, { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 2, indented: true }, { ...{ label: 'SubMenu item', url: '#', id: 1 }, id: 3 }],
  },
]} />
</div>`}
  scope={ { MobileBrowse } }
/>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-mobile-browse --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  